var React = require( 'react' );
var createReactClass = require('create-react-class');
var Video = require( './video.jsx' );
var SymptomMarkdown = require( './symptomMarkdown.jsx' );
var PureRenderMixin = require('react-addons-pure-render-mixin');

var Section = createReactClass( {
	mixins: [PureRenderMixin],
	render: function () {
    	if (this.props.section.format === 'markdown') {
        	return (<SymptomMarkdown payload={this.props.section} />);
		} else if (this.props.section.format === 'html') {
        	return (<SymptomMarkdown payload={this.props.section} />);
		} else if (this.props.section.format === 'video') {
			return (<Video gender='female' video={this.props.section} />);
		} else {
    		// console.log("WARNING:" + this.props.section.format);
		}
	}
});

module.exports = Section;



// WEBPACK FOOTER //
// ./src/common/routes/education/components/layout/section.jsx